// Kept apart from App.tsx so modules like the store can import them without pulling in the UI
export const apiBaseURL = process.env.REACT_APP_API_BASE_URL ?? 'https://clients.visrez.com';
export const interactiveURL = process.env.REACT_APP_INTERACTIVE_URL ?? 'https://interactive.visrez.com';
